import React from 'react';
interface BadgeSwitcherProps {
  isSold?: boolean;
  isExpired?: boolean;
  createdDate: string;
}
const BadgeSwitcher = ({
  createdDate,
  isExpired,
  isSold,
}: BadgeSwitcherProps) => {
  if (isExpired && !isSold) {
    return (
      <span className="bg-yellow-1 rounded-3xl py-1 px-2 w-full h-full text-yellow-2">
        منقضی شد
      </span>
    );
  }
  if (isSold) {
    <span className="bg-white rounded-3xl py-1 px-2 w-full h-full text-gray-8">
      فروخته شده
    </span>;
  }
  if (!isSold && !isExpired) {
    return (
      <span className="bg-blue rounded-3xl py-1 px-2 w-full h-full text-purple">
        {createdDate}
      </span>
    );
  }
  return <></>;
};

export default BadgeSwitcher;
